import React, { useState, useEffect } from "react";

const Status = (props) => {

  const [isActive, setIsActive] = useState(true);

  const toggleActiveInactiveButton = () => {
    setIsActive(!isActive);
  }

  useEffect(() => {
    props.getStatus(isActive)
  },[isActive])
  useEffect(()=>{
    if(props.isReset){
      setIsActive(true); // default Active
      if(props.handleResetState) props.handleResetState();
    }
  },[props.isReset]);

  return (
    <div className="w-full">
      <p className="fs-16 font-weight-700 color-black m-b-10">Status</p>
      <div className='d-flex m-l-2'>
        <div onClick={()=>toggleActiveInactiveButton()} className='flex-item d-flex active-inactive-button m-r-12' style={{ background: !isActive ? "rgba(255, 0, 85, 0.347)" : "" }}>
          <div className='active-inactive-ball flex-item' style={{ background: !isActive ? "rgb(201, 0, 57)" : "", margin: !isActive ? "0 0 0 0" : "" }} />
        </div>
        <p className='flex-item fs-18'>{isActive ? "Active" : "Inactive"}</p>
      </div>
    </div>
  )
}

export default Status;